export default "__VITE_ASSET__DIfbXU3O__"